import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { Text } from 'apps/auth/components/common/Text/Text';
import InputAccount from 'apps/auth/components/form/InputAccount';
import InputBik from 'apps/auth/components/form/InputBik';
import { REQ_ERROR, VALID_ERROR } from 'apps/auth/constants/Constants';
import { accountPropType } from 'apps/auth/helpers/customPropTypes';

import InputDropBox from './InputDropBox';
import { CardRow, HelpMessage } from './styles';

const AccountField = (props) => {
    const isError = (fields, account) => {
        let isError = false;
        if (account.bik && fields[account.bik.name]) {
            isError = fields[account.bik.name].isError;
        }
        if (!isError && account.account && fields[account.account.name]) {
            isError = fields[account.account.name].isError;
        }
        return isError;
    };

    const getError = (fields, account) => {
        if (account.bik && fields[account.bik.name] && fields[account.bik.name].isError) {
            return getErrorMessage(fields, account.bik);
        } else if (account.account && fields[account.account.name] && fields[account.account.name].isError) {
            return getErrorMessage(fields, account.account);
        }
    };

    const getErrorMessage = (fields, field) => {
        const errorMessageKey = field.value ? VALID_ERROR : REQ_ERROR;
        return fields[field.name].errorMessage ? fields[field.name].errorMessage : props.messages[errorMessageKey];
    };

    const account = props.account;
    return (
        <>
            <div>
                {account.bankName && (
                    <CardRow $fullwidth>
                        <InputDropBox formName={props.formName} field={props.fields[account.bankName.name]} />
                    </CardRow>
                )}

                {account.bik && props.fields[account.bik.name] && (
                    <CardRow $fullwidth>
                        <InputBik
                            field={props.fields[account.bik.name]}
                            formName={props.formName}
                            onBlurHandler={props.checkOnBlurBankBik}
                            isClearErrorOnFocus={true}
                            isDetached={true}
                            isNewInput
                        />
                    </CardRow>
                )}

                {account.account && props.fields[account.account.name] && (
                    <CardRow $fullwidth>
                        <InputAccount
                            field={props.fields[account.account.name]}
                            formName={props.formName}
                            onBlurHandler={props.checkOnBlurBankAccount}
                            isDetached={true}
                            isNewInput
                            isFormattedInput
                        />
                    </CardRow>
                )}
            </div>
            {isError(props.fields, account) && (
                <HelpMessage>
                    <Text color="error" size="secondary" variant="paragraph">
                        {getError(props.fields, account)}
                    </Text>
                </HelpMessage>
            )}
        </>
    );
};

AccountField.propsType = {
    formName: PropTypes.string.isRequired,
    account: accountPropType.isRequired,
};

const mapStateToProps = (state, ownProps) => {
    return {
        fields: state.form[ownProps.formName].fields,
        messages: state.messages.jsMessages,
    };
};
export default connect(mapStateToProps, null)(AccountField);
